import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import "date-fns";
import React, { useEffect, useState } from "react";
import { getSuppliers } from "../../../Ancillary/SupplierManagement/helper/supplierManagementHelper";
import SelectableSearch from "../../../base/views/SelectableSearch";
import { Form } from "../../../base/views/useForm";

const useStyles = makeStyles((theme) => ({
  Appcss: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    borderRadius: "15px",
    padding: "30px",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(1, 0, 2),
  },
}));

const initialFValues = {
  storeId: "",
  userId: "",
  tote_no: "",
  ndc: "",
  description: " ",
  quantity_by_ndc: "",
  lot: "",
  suppliers: [],
  selectedSupplier: { id: 0, optionname: "" },
  supplierid: "",
  rano: "",
};

export default function SaleableReturnForm(props) {
  const classes = useStyles();
  const [errors, setErrors] = React.useState({});
  const [saleableReturnData, setSaleableReturnData] = useState(initialFValues);
  const [supplierData, setSupplierData] = React.useState({
    load: false,
    values: [],
  });

  const validate = (fieldValues = saleableReturnData) => {
    let temp = {};
    if ("supplier" in fieldValues) {
      temp.selectedSupplier =
        fieldValues.selectedSupplier.optionname === ""
          ? "Supplier is required"
          : "";
    }
    if ("toteno" in fieldValues) {
      temp.tote_number =
        fieldValues.tote_number === "" ? "Tote # is required" : "";
    }
    setErrors({
      ...temp,
    });
    return Object.values(temp).every((x) => x === "");
  };

  const resetForm = () => {
    setSaleableReturnData(initialFValues);
    setErrors({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSaleableReturnData({
      ...saleableReturnData,
      [name]: value,
    });
  };

  const { addOrEdit, recordForEdit, editSaleableReturn } = props;

  const HandleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      editSaleableReturn(saleableReturnData);
      addOrEdit(resetForm);
    }
  };
  useEffect(() => {
    if (recordForEdit != null)
      setSaleableReturnData({
        ...recordForEdit,
        tote_number: recordForEdit.toteno,
        selectedSupplier: {
          id: recordForEdit.supplierid,
          optionname: recordForEdit.supplier,
        },
      });
  }, [recordForEdit]);

  const loadSupplierDropdown = () => {
    setSupplierData({ ...supplierData, load: true });
    getSuppliers(recordForEdit.storeId)
      .then((response) => {
        let dropdownData = [];
        if (response.data.length)
          dropdownData = response.data.map((obj) => ({
            id: obj.supplier_id,
            optionname: obj.name,
          }));
        setSupplierData({ load: false, values: dropdownData });
      })
      .catch((err) => {});
  };

  const handleSupplierChange = (event, value) => {
    if (value && value.id) {
      setSaleableReturnData({
        ...saleableReturnData,
        selectedSupplier: { id: value.id, optionname: value.optionname },
      });
    } else {
      setSaleableReturnData({
        ...saleableReturnData,
        selectedSupplier: {},
      });
    }
  };

  return (
    <Form onSubmit={HandleSubmit}>
      <Container component="main" maxWidth="lg">
        <div className={classes.form}>
          <Grid container spacing={2}>
            <Grid item sm={5}>
              <SelectableSearch
                autoFocus
                value={saleableReturnData.selectedSupplier}
                data={supplierData}
                name="supplier"
                label="Supplier"
                id="supplier"
                loading={loadSupplierDropdown}
                onChangeEvent={handleSupplierChange}
                variantType="standard"
                {...(errors.selectedSupplier && {
                  error: true,
                  helperText: errors.selectedSupplier,
                })}
              ></SelectableSearch>
            </Grid>
            <Grid item sm={3}>
              <TextField
                value={saleableReturnData.rano}
                autoComplete="ra_number"
                name="rano"
                variant="standard"
                required
                fullWidth
                disabled
                id="rano"
                label="RA number"
                className={classes.submit}
              />
            </Grid>
            <Grid item sm={4}>
              <TextField
                value={saleableReturnData.tote_number}
                autoComplete="tote_number"
                name="tote_number"
                variant="standard"
                required
                fullWidth
                id="tote_number"
                label="TOTE number"
                className={classes.submit}
                onChange={handleInputChange}
                {...(errors.tote_number && {
                  error: true,
                  helperText: errors.tote_number,
                })}
              />
            </Grid>
          </Grid>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            style={{ width: "20vw" }}
            type="submit"
          >
            Submit
          </Button>
        </div>
      </Container>
    </Form>
  );
}
